import React from 'react';
import { MdWarning, MdInfo, MdError, MdCheckCircle } from 'react-icons/md';
import './ConfirmDialog.css';

function ConfirmDialog({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirmação', 
  message, 
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning' // warning, info, error, success
}) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <MdWarning size={48} color="#ff9800" />;
      case 'error':
        return <MdError size={48} color="#f44336" />;
      case 'success':
        return <MdCheckCircle size={48} color="#4caf50" />;
      case 'info':
      default:
        return <MdInfo size={48} color="#E3A864" />;
    }
  };

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="confirm-dialog-overlay" onClick={onClose}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-dialog-icon ${type}`}>
          {getIcon()}
        </div>
        
        <div className="confirm-dialog-content">
          <h2 className="confirm-dialog-title">{title}</h2>
          <div className="confirm-dialog-message">
            {message.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>

        <div className="confirm-dialog-actions">
          <button 
            className="btn-secondary" 
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button 
            className={`btn-primary ${type}`}
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDialog;
